import type { FunctionComponent } from 'react';

import { Title } from '../title';
import ChatCard from './chat-card';

import styles from './styles.module.scss';

export interface ChatCardsProps {
  toolIds: string[];
}

export const ChatCards: FunctionComponent<ChatCardsProps> = (props: ChatCardsProps) => {
  return (
    <div>
      <Title htmlMarkup={'h2'} visualHeading={'h3'}>
        {'Du kan snakke med:'}
      </Title>
      <div className={styles['chatcards-text']}>
        <ul>
          <li>{'helsesykepleier på skolen'}</li>
          <li>{'helsestasjon for ungdom'}</li>
          <li>{'fastlegen'}</li>
          <li>{'en voksen du stoler på'}</li>
        </ul>
      </div>
      <div className={styles['chatcards-wrapper']}>
        <Title htmlMarkup={'h3'} visualHeading={'h4'}>
          {'Du kan også ta kontakt med en av tjenestene under:'}
        </Title>
        <div className={styles['chatcards-wrapper__tools']}>
          {props.toolIds.map(toolId => (
            <ChatCard key={toolId} toolId={toolId} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ChatCards;
